import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Routes/Home';
import About from './Routes/About';
import './App.css';
import Team from './Routes/Team';
import { ToastContainer } from 'react-toastify';

function App() {
	return (
        <>
		<BrowserRouter>
			<Routes>
				<Route path='/' exact element={<Home />} />
				<Route path='/home' element={<Home />} />
				<Route path='/about' exact element={<About />} />
				{/* <Route path='/services' exact element={<Services />} /> */}
				<Route path='/our-team' exact element={<Team />} />
				{/* <Route path='/my-blog' exact element={<Blog />} /> */}
				{/* <Route path='/contact' exact element={<Contact />} /> */}
				<Route path='/home' element={<Navigate replace to='/' />} />
				<Route path='*' element={<Navigate replace to='/' />} />
			</Routes>
		</BrowserRouter>
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            />
        </>
	);
}

export default App;
